import { computed } from "vue";
import { useRoute } from "vue-router";

import useAuthorization from "@/composition/shared/useAuthorization.ts";
import { useUserStore } from "@/stores/user.ts";

export default function useGlobalModals() {
  const route = useRoute();
  const userStore = useUserStore();
  const {
    isPermittedForDesk,
    isPermittedForMessenger,
    isPermittedForCvd,
    isPermittedForAiResearch,
  } = useAuthorization();

  const isAppRoute = computed(() => (route.meta.access ?? "app") === "app");

  const showTermsOfService = computed(
    () => isAppRoute.value && !!userStore.termsOfServiceAgreementRequired,
  );

  const isPermittedForCurrentApp = () => {
    switch (route.meta.application) {
      case "messenger":
        return isPermittedForMessenger();
      case "cvd":
        return isPermittedForCvd();
      case "ai-research":
        return isPermittedForAiResearch();
      default:
        return isPermittedForDesk();
    }
  };

  const showWelcome = computed(
    () =>
      isAppRoute.value &&
      !userStore.termsOfServiceAgreementRequired &&
      !userStore.preferences.suppressOnboardingTour &&
      isPermittedForCurrentApp(),
  );

  return { showTermsOfService, showWelcome };
}
